
import List from '@/ui-kit/components/list';
import ListItem from '@/ui-kit/components/list-item';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import { track } from '@/utils/analytics';
import routes from '@/constants/routes';
import { NAVIGATION_LIST } from '../constants';

export default {
  name: 'ContainerOverviewNavigationList',
  components: {
    List,
    ListItem,
    Typography,
  },
  data() {
    return {
      NAVIGATION_LIST,
      TypographyType,
      routes,
    };
  },
  methods: {
    handleListItemClick(path, title) {
      this.trackNavigation(title);
      this.$router.push(path);
    },
    trackNavigation(title) {
      track(`My Abode_${title} nav link click`);
    },
    getActiveNav(path) {
      return new StyleClassNamesBuilder('container-overview-navigation-list__item')
        .addConditionClassName('active', path === this.$route.path)
        .build();
    },
  },
};
